import type { ButtonHTMLAttributes, Ref } from 'react';
import styles from './IconButton.module.css';

interface IIconButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'type'> {
  /** Icon-only, so this is the button's name. */
  'aria-label': string;
  ref?: Ref<HTMLButtonElement>;
}

/** The map toolbars' square icon button: surface fill, hairline border. */
export function IconButton({ className, ref, ...button }: IIconButtonProps) {
  return <button ref={ref} type="button" className={[styles.iconButton, className].join(' ')} {...button} />;
}
